import { useEffect, useState } from "react";
import Image from "next/image";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { colors } from "@theme/colors";

const styles = {
  image: {
    width: "100%",
    overflow: "hidden",
    "& > img": {
      width: "100%",
    },
  },
};

const shimmer = (w, h) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="${colors.secondary.linen}" offset="20%" />
      <stop stop-color="${colors.common.white}" offset="50%" />
      <stop stop-color="${colors.secondary.linen}" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="${colors.secondary.linen}" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;

const toBase64 = (str) =>
  typeof window === "undefined"
    ? Buffer.from(str).toString("base64")
    : window.btoa(str);

export default function CustomImage({ imageUrl, alt, boxStyles, ...props }) {
  const [src, setSrc] = useState(imageUrl);

  useEffect(() => {
    if (imageUrl && imageUrl !== src) {
      setSrc(imageUrl);
    } else if (!imageUrl) {
      setSrc("/assets/images/not-available.png");
    }
  }, [imageUrl]);

  return (
    <Box
      sx={{
        ...styles.image,
        ...boxStyles,
      }}
    >
      <Image
        src={src}
        width={1000}
        height={1000}
        layout="responsive"
        placeholder="blur"
        blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(700, 475))}`}
        onError={() => setSrc("/assets/images/not-available.png")}
        alt={alt}
        {...props}
      />
    </Box>
  );
}

CustomImage.defaultProps = {
  boxStyles: {},
  alt: "",
};

CustomImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  alt: PropTypes.string,
  boxStyles: PropTypes.object,
};
